import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=36422595&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&id=36422595&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36422595",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36422595')) {
      api.createRecord('36422595', component.options)
    } else {
      api.reload('36422595', component.options)
    }
    module.hot.accept("./SidebarItem.vue?vue&type=template&id=36422595&scoped=true", function () {
      api.rerender('36422595', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/layout/SidebarItem.vue"
export default component.exports